import { environment } from './../../../environments/environment';

export class FileUtilities {
  /** Returns the input string formatted as Title Case. */
  public static fileUrl(filepath: string): string {
    if (filepath)
      return `${environment.dbApi.baseUrl}/documents/read/?file=${filepath}`;
    else return '';
  }
}
